// Third party
import axios from 'axios';

// Components
import { getAuthHeaders } from '../utils';
import { REACT_APP_DATA_API_URL, DEV_APP_API_URL } from '../constants';

export function DashboardController() {
  const getDashboardScores = async <T>(user_id?: number): Promise<T> => {
    return await axios.get(`${REACT_APP_DATA_API_URL}/analytics/users/${user_id}/shots/scores?days_n=30`, {
      headers: getAuthHeaders(),
      params: {
        days_n: 365,
      }
    });
  };

  const getDashboardWorstPresentations = async <T>(): Promise<T> => {
    return await axios.get(`${DEV_APP_API_URL}/api/v1/dashboard/linearity-error`, {
      headers: getAuthHeaders(),
      params: {
        days_n: 365,
      }
    });
  };

  const getDashboardTotalTrainTime = async <T>(user_id?: number): Promise<T> => {
    return await axios.get(`${REACT_APP_DATA_API_URL}/analytics/users/${user_id}/scenario-stats/total-train-time?days_n=365`, {
      headers: getAuthHeaders(),
    });
  };

  const getDashboardRankings = async <T>(): Promise<T> => {
    return await axios.get(`${DEV_APP_API_URL}/api/v1/dashboard/rankings`, {
      headers: getAuthHeaders(),
      params: {
        days_n: 365,
      }
    });
  };

  return { getDashboardScores, getDashboardTotalTrainTime, getDashboardWorstPresentations, getDashboardRankings };
}
